import { type PropsWithChildren } from 'react';

import { type PlatformID } from '@common/clients/api';
import styles from '@web/templates/ErrorPages/organisms/ErrorIntroBlock/ErrorIntroBlock.module.scss';

import { ErrorBackground } from '../../molecules/ErrorBackground';

interface Props extends PropsWithChildren {
    platformID?: PlatformID;
}

export const ErrorIntroBlock = ({ children, platformID }: Props) => {
    return (
        <section className={[styles.ErrorIntroBlock, 'inverted'].join(' ')}>
            <ErrorBackground platformID={platformID} />
            {children}
        </section>
    );
};
